// lull-blog-sidebar-v3.js — works regardless of script load order vs DOM
(function () {
  'use strict';

  function initMobileCta(cta) {
    var raf;
    function show() {
      if (window.innerWidth <= 767) {
        if (window.scrollY > 80) {
          cta.classList.add('lull-mob-visible');
        } else {
          cta.classList.remove('lull-mob-visible');
        }
      } else {
        cta.classList.remove('lull-mob-visible');
      }
    }
    function tick() {
      if (!raf) raf = requestAnimationFrame(function () { raf = null; show(); });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', show);
    show();
  }

  function findAndInit() {
    var cta = document.getElementById('lull-mob-cta');
    if (cta) { initMobileCta(cta); return true; }
    return false;
  }

  // Try immediately (script after CTA in DOM)
  if (findAndInit()) return;

  // Script loaded before CTA — watch for it
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function () {
      if (findAndInit()) obs.disconnect();
    });
    obs.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  // DOMContentLoaded fallback
  document.addEventListener('DOMContentLoaded', function () {
    if (findAndInit() && typeof obs !== 'undefined') obs.disconnect();
  });
})();
